import { loader } from 'graphql.macro'

export default async function createResourceImport ({ dataLoaders, variables }) {
  const schema = loader('./createResourceImport.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      signedId: variables.signedId
    }
  })
  return response.createResourceImport
}
